/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect } from 'react';
import './panel-facturacion.css';
import { useTranslation } from 'react-i18next';
import { getGeoData } from 'frontend/redux/actions/application-actions';
import { useDispatch, useSelector } from 'react-redux';
import applicationSelectors from 'frontend/redux/selectors/application-selectors';
import DropDown from '../../../commons/dropdown/dropdown';

const PanelFacturacion = (props) => {
  const inputClasses = 'shadow appearance-none border rounded w-full py-2 px-3 text-gray-400 text-xs leading-tight focus:outline-none focus:shadow-outline';
  const labelClasses = 'block text-gray-700 text-sm mb-2';
  const { t } = useTranslation('translations');
  const dispatch = useDispatch();
  const provinces = useSelector(applicationSelectors.cities);

  useEffect(() => {
    dispatch(getGeoData());
  }, []);

  return (
    <div>
      <div className='clearfix' />
      <div className='container bg-white my-4 p-6'>
        <div className='panel-body'>
          <div className='grid-cols-3 gap-4 text-sm sm:grid grid-cols-1'>
            <div className='col-span-2'>
              <div className='block text-gray-700 text-3xl mb-2'>
                <i className='fa fa-shopping-cart color-negro-claro' aria-hidden='true' />
              </div>
            </div>
            <div className='col-span-1'>
              <label className={labelClasses}>
                <input type='checkbox' onChange={props.utilizarDatosPasajeroUno} id='usar-datos-pax-1' data-name='uso_datos_pasajero_uno' />
                {t('checkout.dataPassengerNow')}
              </label>
            </div>
            <div className='col-span-1'>
              <div className='form-group'>
                <label className={labelClasses} htmlFor='nombre-facturacion'>
                  {t('checkout.name')}
                </label>
                <input onChange={props.actualizarDatosFacturacion} data-name='nombre' id='nombre-facturacion' name='nombre-facturacion' type='text' placeholder={t('checkout.nameTip')} className={inputClasses} required />
              </div>
            </div>
            <div className='col-span-1'>
              <div className='form-group'>
                <label className={labelClasses} htmlFor='apellido-facturacion'>
                  {t('checkout.lastName')}
                </label>
                <input onChange={props.actualizarDatosFacturacion} data-name='apellido' id='apellido-facturacion' name='apellido-facturacion' type='text' placeholder={t('checkout.nameTip')} className={inputClasses} required />
              </div>
            </div>
            <div className='col-span-1'>
              <div className='grid-cols-2 gap-4 text-sm sm:grid grid-cols-1'>
                <div className='col-span-1'>
                  <div className='form-group'>
                    <label className={labelClasses} htmlFor='tipo-documento-facturacion'>
                      {t('checkout.idType')}
                    </label>
                    <select onChange={props.actualizarDatosFacturacion} data-name='tipo_documento' id='tipo-documento-facturacion' name='tipo-documento-facturacion' className={inputClasses} required>
                      <option value=''>{t('checkout.select')}</option>
                      <option value='DNI'>{t('checkout.dni')}</option>
                      <option value='CI'>CI</option>
                    </select>
                  </div>
                </div>
                <div className='col-span-1'>
                  <div className='form-group'>
                    <label className={labelClasses} htmlFor='numero-documento-facturacion'>
                      {t('checkout.idNumber')}
                    </label>
                    <input onChange={props.actualizarDatosFacturacion} data-name='nro_documento' id='numero-documento-facturacion' name='numero-documento-facturacion' type='number' placeholder='Ingrese el numero sin espacios' className={inputClasses} required />
                    <div className='clearfix' />
                  </div>
                </div>
              </div>
            </div>
            <div className='col-span-1'>
              <div className='form-group'>
                <div className='clearfix' />
                <label className={labelClasses} htmlFor='provincia-facturacion'>{t('checkout.province')}</label>
                <DropDown
                  onChange={props.onProvinceChange}
                  data={provinces}
                  data-name='provincia'
                  id='provincia-facturacion'
                  name='provincia-facturacion'
                  required
                />
              </div>
            </div>
            <div className='col-span-1'>
              <div className='form-group'>
                <label className={labelClasses} htmlFor='localidad-facturacion'>{t('checkout.city')}</label>
                <DropDown
                  onChange={props.onCityChange}
                  data={props.localities}
                  data-name='localidad'
                  id='localidad-facturacion'
                  name='localidad-facturacion'
                  className={inputClasses}
                  required
                />
              </div>
            </div>
            <div className='col-span-1'>
              <div className='form-group'>
                <label className={labelClasses} htmlFor='direccion-facturacion'>{t('checkout.address')}</label>
                <input onChange={props.actualizarDatosFacturacion} data-name='direccion' id='direccion-facturacion' name='direccion-facturacion' type='text' placeholder='Ingrese su domicilio' className={inputClasses} required />
              </div>
            </div>
            <div className='col-span-1'>
              <div className='grid-cols-2 gap-4 text-sm sm:grid grid-cols-1'>
                <div className='col-span-1'>
                  <div className='form-group'>
                    <label className={labelClasses} htmlFor='piso-facturacion'>{t('checkout.floor')}</label>
                    <input onChange={props.actualizarDatosFacturacion} data-name='piso' id='piso-facturacion' name='piso-facturacion' type='text' placeholder='' className={inputClasses} />
                  </div>
                </div>
                <div className='col-span-1'>
                  <div className='form-group'>
                    <label className={labelClasses} htmlFor='departamento-facturacion'>{t('checkout.apartment')}</label>
                    <input onChange={props.actualizarDatosFacturacion} data-name='departamento' id='departamento-facturacion' name='departamento-facturacion' type='text' placeholder='' className={inputClasses} />
                  </div>
                </div>
              </div>
            </div>
            <div className='col-span-1'>
              <div className='form-group'>
                <label className={labelClasses} htmlFor='telefono-facturacion'>{t('checkout.phone')}</label>
                <input onChange={props.actualizarDatosFacturacion} data-name='telefono' id='telefono-facturacion' name='telefono-facturacion' type='text' placeholder='Te llamaramos para confirmar que recibiste todo' className={inputClasses} required />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PanelFacturacion;
